// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * GDS API Internal
 * <!-- used by swagger --> An Internal API to manage Aura Graph Analytics Sessions. Intended to be used by other components inside Aura. These endpoints require mtls and are not exposed to the public.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EndpointsError } from './EndpointsError';
import {
  EndpointsErrorFromJSON,
  EndpointsErrorFromJSONTyped,
  EndpointsErrorToJSON,
  EndpointsErrorToJSONTyped,
} from './EndpointsError';
import type { InternalendpointsModelDetails } from './InternalendpointsModelDetails';
import {
  InternalendpointsModelDetailsFromJSON,
  InternalendpointsModelDetailsFromJSONTyped,
  InternalendpointsModelDetailsToJSON,
  InternalendpointsModelDetailsToJSONTyped,
} from './InternalendpointsModelDetails';

/**
 *
 * @export
 * @interface InternalModelsIdGet200Response
 */
export interface InternalModelsIdGet200Response {
  /**
   *
   * @type {InternalendpointsModelDetails}
   * @memberof InternalModelsIdGet200Response
   */
  data?: InternalendpointsModelDetails;
  /**
   *
   * @type {Array<EndpointsError>}
   * @memberof InternalModelsIdGet200Response
   */
  errors?: Array<EndpointsError>;
}

/**
 * Check if a given object implements the InternalModelsIdGet200Response interface.
 */
export function instanceOfInternalModelsIdGet200Response(
  value: object,
): value is InternalModelsIdGet200Response {
  return true;
}

export function InternalModelsIdGet200ResponseFromJSON(
  json: any,
): InternalModelsIdGet200Response {
  return InternalModelsIdGet200ResponseFromJSONTyped(json, false);
}

export function InternalModelsIdGet200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InternalModelsIdGet200Response {
  if (json == null) {
    return json;
  }
  return {
    data:
      json['data'] == null
        ? undefined
        : InternalendpointsModelDetailsFromJSON(json['data']),
    errors:
      json['errors'] == null
        ? undefined
        : (json['errors'] as Array<any>).map(EndpointsErrorFromJSON),
  };
}

export function InternalModelsIdGet200ResponseToJSON(
  json: any,
): InternalModelsIdGet200Response {
  return InternalModelsIdGet200ResponseToJSONTyped(json, false);
}

export function InternalModelsIdGet200ResponseToJSONTyped(
  value?: InternalModelsIdGet200Response | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: InternalendpointsModelDetailsToJSON(value['data']),
    errors:
      value['errors'] == null
        ? undefined
        : (value['errors'] as Array<any>).map(EndpointsErrorToJSON),
  };
}
